module.exports = __webpack_public_path__ + "img/logo-reduzido-gradiente-x.4263d390.png";